import type { ReactNode } from "react";
import { useSuppressMobileBottomNav } from "../../hooks/useSuppressMobileBottomNav";

/** Bottom padding for pages with a mobile sticky action bar (~bar height + safe area). */
export const MOBILE_STICKY_BAR_PAD = "pb-28";

interface MobileStickyBarProps {
  active: boolean;
  children: ReactNode;
}

/** Fixed mobile footer that suppresses the bottom tab bar while visible. */
export function MobileStickyBar({ active, children }: MobileStickyBarProps) {
  useSuppressMobileBottomNav(active);

  if (!active) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-white/5 bg-brand-dark/95 p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] backdrop-blur-lg lg:hidden">
      {children}
    </div>
  );
}
